module.exports = __webpack_public_path__ + "static/media/095-puzzle.9e47feea.svg";